import { Skeleton } from '@shared/components/Skeleton';
import React from 'react';

export const DefaultSkeleton = () => {
  return (
    <Skeleton
      width="250px"
      height="10rem"
      borderRadius="10px"
    />
  );
};
